import React from "react";
import PropTypes from "prop-types";
import { orderBy } from "lodash";
import { Row, Col } from "react-bootstrap";
import CustomerSelect from "../../common/CustomerSelect";
import UserSelect from "../../common/UserSelect";
import DropdownSearch from "../../common/DropdownSearch";

import ReportFilters from "../ReportFiltersComponent";

const CustomerBalanceSummaryFilters = ({
  onChange,
  codes,
  filters,
  fetchData,
  handleResetFilters,
  loading,
  onExportClick,
  exportDisabled
}) => {
  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      ?.filter((code) => code.entity === entity && code.field === field)
      ?.map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, [(option) => option.label.toLowerCase()]);
  };

  return (
    <ReportFilters
      onFetchClick={() => fetchData()}
      onResetClick={handleResetFilters}
      title="Prepaid Customer Balance Summary"
      loading={loading}
      csvExportAvailable
      onCSVExport={onExportClick}
      exportDisabled={loading || exportDisabled}
    >
      <Row>
        <Col md={3}>
          <CustomerSelect
            label="Customer"
            placeholder="Select"
            isMulti
            value={filters.customer || []}
            onChange={(e) => onChange("customer")(e || [])}
          />
        </Col>
        <Col md={3}>
          <UserSelect
            label="Salesperson"
            placeholder="Select"
            value={filters.salesperson || null}
            onChange={(e) => onChange("salesperson")(e?.value || null)}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            rowStyles={{ marginTop: 0 }}
            isMulti
            placeholder="Select"
            label="Call Status"
            name="stage"
            onChange={(name, value) => onChange("stage")(value || [])}
            value={filters.stage || []}
            data={[...generateCodeOptions("Call", "status")]}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            Prepaid Balance % Under
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            name="balance"
            placeholder="Type"
            type="number"
            value={filters.balance || ""}
            onChange={(e) => onChange("balance")(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            End Date
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            name="end_date"
            type="date"
            value={filters.end_date}
            onChange={(e) => onChange("end_date")(e.target.value)}
          />
        </Col>
      </Row>
    </ReportFilters>
  );
};

CustomerBalanceSummaryFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  codes: PropTypes.array,
  filters: PropTypes.object,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  exportDisabled: PropTypes.bool
};
export default CustomerBalanceSummaryFilters;
